@if (state.avatarUrl) {
  <dojo-icon (click)="clicked.emit()" [icon]="state.avatarUrl" type="img" [size]="size()" />
} @else if (state.user) {
  <dojo-avatar (click)="clicked.emit()" [name]="state.user.fullName" [size]="size() ? size() : 30" />
}
